import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useReportTemplate(id) {
  const [reportTemplate, setReportTemplate] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.report_templates.show(id))
      .then((response) => {
        setReportTemplate(response.data.data);
      });
  }, []);

  return reportTemplate;
}
